/**
 * MOCK MODE'S SEAM IN THE API CLIENT. While a transport is installed, every
 * request the client makes (reads, writes, streams) is answered by it and
 * nothing reaches the network: an endpoint it has no answer for fails loudly
 * (`ApiError`, "No mock for GET /x") instead of quietly reading real data.
 *
 * The transport itself lives in `src/mocks` (loaded only when mock mode is on,
 * see `lib/mock-mode.ts`); this file is only the socket it plugs into, so the
 * client stays below every other layer.
 */
export interface MockRequest {
  method: string;
  /** The endpoint as the client was given it: path and query (`/managed/money?teamId=1`). */
  endpoint: string;
  body: unknown;
}

export type MockAnswer =
  /** The JSON body the API would have sent (null for an empty body). */
  | { kind: 'json'; body: unknown }
  /** A streamed answer (`api.stream`). */
  | { kind: 'response'; response: Response }
  /** An HTTP failure the API would have answered; `body` defaults to `{ error: message }`. */
  | { kind: 'error'; status: number; message: string; body?: unknown };

export type MockTransport = (request: MockRequest) => Promise<MockAnswer | null>;

let transport: MockTransport | null = null;

export function setMockTransport(next: MockTransport | null): void {
  transport = next;
}

export function mockTransport(): MockTransport | null {
  return transport;
}
